import { useLocation, Link } from "react-router-dom";
import { SCHEDULE_PATH } from "@/constants/links";

// @ts-ignore - injected at build time by Vite define
const commitHash: string = typeof __GIT_COMMIT_HASH__ !== "undefined" ? __GIT_COMMIT_HASH__ : "dev";
// @ts-ignore
const commitTimestamp: string = typeof __GIT_COMMIT_TIMESTAMP__ !== "undefined" ? __GIT_COMMIT_TIMESTAMP__ : "";

const footerLinks = [
  { label: "Home", hash: "" },
  { label: "Services", hash: "#services" },
  { label: "Team", hash: "#team" },
  { label: "Insights", hash: "#insights" },
];

const Footer = () => {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <footer className="py-12 border-t border-border">
      <div className="container mx-auto px-6">
        <div className="flex flex-col items-center gap-6">
          <a href={isHome ? "#" : "/"} className="flex items-center gap-2">
            <img src="/images/tn-logo.png" alt="TechNeed Solutions logo" className="h-8 w-auto" width={32} height={32} />
            <span className="font-heading font-semibold text-foreground">TechNeed Solutions</span>
          </a>

          <p className="text-sm text-muted-foreground text-center max-w-md">
            Clarity, momentum, and a partner who understands both your business and technology.
          </p>

          <Link
            to={SCHEDULE_PATH}
            className="text-sm font-medium text-primary hover:text-primary/80 underline underline-offset-4 transition-colors"
          >
            Schedule a conversation →
          </Link>

          <div className="flex flex-wrap items-center justify-center gap-4 sm:gap-6 text-sm text-muted-foreground">
            {footerLinks.map((link) => (
              <a
                key={link.label}
                href={isHome ? (link.hash || "/") : `/${link.hash}`}
                className="hover:text-foreground transition-colors"
              >
                {link.label}
              </a>
            ))}
          </div>

          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} TechNeed Solutions. All rights reserved.
          </p>
          <p className="text-[10px] text-muted-foreground/70 font-mono tracking-tight">
            Hash {commitHash}
            {commitTimestamp && (
              <span className="ml-2">
                {new Date(commitTimestamp).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "short",
                  day: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </span>
            )}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
